import { useMutation } from "@tanstack/react-query";
import { CelebrationType } from "./metricsApi";
import { TextType, generatePlanText, postOutreachSms } from "./aiApi";
import { PlanForm } from "src/pages/Plans/PlanDrawer/PlanDrawer.types";

export function usePostOutreachSms() {
  return useMutation({
    mutationFn: ({
      memberName,
      gymName,
      numberOfYears,
      celebrationType
    }: {
      memberName: string;
      gymName: string;
      numberOfYears?: number;
      celebrationType: CelebrationType;
    }) => postOutreachSms({ memberName, gymName, numberOfYears, celebrationType }),
  });
}

export function useGeneratePlanText() {
  return useMutation({
    mutationFn: ({
      textType,
      plan
    }: {
      textType: TextType;
      plan: PlanForm;
    }) => generatePlanText({ textType, plan }),
  });
}
